"use client";

import * as React from "react";
import { FileText, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ExpressionOfInterestDoorFurnitureThresholds() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="expression-of-interest-door-furniture-thresholds" className="w-full py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4 max-w-4xl">
        <div ref={ref} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Card className="relative overflow-hidden border-border shadow-md">
            <div className="absolute -top-24 -right-24 size-48 rounded-lg bg-primary/5 blur-3xl pointer-events-none" aria-hidden="true" />
            <div className="absolute -bottom-24 -left-24 size-48 rounded-lg bg-primary/5 blur-3xl pointer-events-none" aria-hidden="true" />

            <CardContent className="p-0">
              <div className="relative z-10 flex flex-col md:flex-row items-center md:items-start p-8 md:p-12 gap-8">
                <div className="flex flex-col items-center gap-6 shrink-0">
                  <div className="flex size-20 items-center justify-center rounded-lg bg-primary/10 text-primary ring-8 ring-primary/5">
                    <FileText className="size-10" strokeWidth={1.5} />
                  </div>
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1641543/img/commercial_door_hardware_schematic.png" alt="Door Furniture and Thresholds Technical Drawing" className="h-24 md:h-32 w-auto object-contain opacity-90" />
                </div>

                <div className="flex-1 flex flex-col items-center md:items-start text-center md:text-left space-y-6">
                  <div className="space-y-1">
                    <h2 className="text-3xl font-bold tracking-tight font-default text-foreground sm:text-4xl">
                      Expression of Interest
                    </h2>
                    <h3 className="text-primary font-mono text-sm md:text-base font-semibold uppercase tracking-wider">
                      Door Furniture & Thresholds
                    </h3>
                  </div>

                  <p className="text-lg text-muted-foreground max-w-2xl leading-relaxed">
                    Download the complete Expression of Interest (EOI) document covering detailed specifications, requirements, and submission guidelines for door furniture and thresholds.
                  </p>

                  <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto">
                    <Button size="lg" className="w-full sm:w-auto gap-2 text-base h-14 px-8 rounded-lg shadow-sm" asChild>
                      <Link to="https://bottomupprojects.com.au/wp-content/uploads/2026/10/EOI-SUPPLY-INSTALL-Door-Furniture-Floor-Threasholds.pdf" newTab>
                        <Download className="size-5" />
                        <span>Download EOI Document</span>
                      </Link>
                    </Button>
                    
                    <p className="text-xs text-muted-foreground/60 whitespace-nowrap">
                      PDF Format • 2.4 MB • Updated recently
                    </p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}